import { jsx as _jsx } from "react/jsx-runtime";
import { getOccupationSuggestions } from "@/graphql/queries/FilterAutocomplete";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { SearchInput } from "../SearchAutocompleteInput";
import { SearchFormContext } from "../SearchFormContext";
export function OccupationAutocompleteInput() {
    var _a = useContext(SearchFormContext), occupationParamKey = _a.occupationParamKey, occupationValue = _a.occupationValue, setOccupationValue = _a.setOccupationValue;
    return (_jsx(SearchInput, { placeholder: "Occupation", paramKey: occupationParamKey, value: occupationValue, setValue: setOccupationValue, gqlQuery: getOccupationSuggestions, icon: _jsx(FontAwesomeIcon, { icon: faBriefcase }) }));
}
